/* tslint:disable */
/* eslint-disable */
export enum ApplicationSubmissionOptions {
  None = 'None',
  Minimal = 'Minimal',
  ValidateAutoApproval = 'ValidateAutoApproval',
  QuoteOnly = 'QuoteOnly',
  AttemptAutoApproval = 'AttemptAutoApproval'
}
